import { PageLoader } from '@/shared/components/loader/page-loader';
import { NewSynclyLogo } from '@/shared/components/new-syncly-logo';
import { Button } from '@/shared/components/shadcn/button';
import { GoogleLogo, MicrosoftLogo } from '@/shared/icons/index';

export const LoginPageTemplate = ({
  title,
  description,
  signInLoading,
  onSignInWithGoogleClick,
  onSignInWithMicrosoftClick,
}: {
  title: string;
  description: string;
  signInLoading: boolean;
  onSignInWithGoogleClick: () => void;
  onSignInWithMicrosoftClick: () => void;
}) => {
  return (
    <div className="bg-background relative flex h-screen w-full gap-6 p-6">
      {signInLoading && <PageLoader overlay={true} className="z-10" />}
      {/* Left Panel - Login Form */}
      <div className="flex flex-1 flex-col items-center justify-center">
        <div className="flex w-full max-w-90 flex-col gap-12">
          {/* Logo and Header */}
          <div className="flex flex-col gap-6">
            <NewSynclyLogo className="size-8" />
            <div className="flex flex-col gap-3">
              <h1 className="text-foreground text-[30px] leading-9 font-bold">{title}</h1>
              <p className="text-muted-foreground text-sm">{description}</p>
            </div>
          </div>

          {/* Sign In Buttons */}
          <div className="flex flex-col gap-3">
            <Button
              variant="outline"
              className="h-10 w-full"
              onClick={() => {
                onSignInWithGoogleClick();
              }}
              disabled={signInLoading}
            >
              <GoogleLogo className="size-4" />
              Continue with Google
            </Button>

            <Button
              variant="outline"
              className="h-10 w-full"
              onClick={onSignInWithMicrosoftClick}
              disabled={signInLoading}
            >
              <MicrosoftLogo className="size-4" />
              Continue with Microsoft
            </Button>

            <p className="text-muted-foreground text-center text-xs">Please use your work email</p>
          </div>

          {/* Terms and Privacy */}
          <div className="flex flex-col gap-1">
            <p className="text-muted-foreground text-xs">By proceeding,</p>
            <div className="flex flex-wrap items-center gap-1 text-xs">
              <span className="text-muted-foreground">you agree to the</span>
              <a
                href="https://syncly.app/terms"
                target="_blank"
                className="text-foreground underline underline-offset-2"
              >
                Terms and Conditions
              </a>
              <span className="text-muted-foreground">and</span>
              <a
                href="https://syncly.app/privacy"
                target="_blank"
                className="text-foreground underline underline-offset-2"
              >
                Privacy Policy
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Right Panel - Image with Quote */}
      <div className="relative flex h-full flex-1 overflow-hidden rounded-xl">
        {/* Image with object-cover to maintain aspect ratio */}
        <img
          src="/assets/login-bg.webp"
          alt="Login background"
          className="absolute inset-0 h-full w-full object-cover"
        />

        {/* Gradient overlay */}
        <div
          className="absolute inset-0"
          style={{
            // FIXME: refine
            background:
              'linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.04) 55.63%, rgba(0, 0, 0, 0.4) 73.152%, rgba(0, 0, 0, 0.6) 100%)',
          }}
        />
      </div>
    </div>
  );
};
